module.exports = __webpack_public_path__ + "static/media/star.94a0ccb7.svg";